import ScrollMagic from 'scrollmagic';
import formFilter from '../components/filter-table';
import bewiMap from '../components/maps';
import lightbox from 'lightbox2';
import Player from '@vimeo/player';
import Splide from '../components/splide';

require('intersection-observer');

function clear_select(id)
{ 
  const element = document.getElementById(id);
  if (element) {
    while (element.lastChild.value !== 'all') {
      element.removeChild(element.lastChild);
    }
  }
}

function render_select(val)
{
  const select_two_els = document.getElementById('select_id_2').querySelectorAll('option');
  const select_tmp_el = document.getElementById('select_id_2_tmp');
  if (select_two_els.length > 0 && select_tmp_el) {
    Array.from(select_two_els).forEach((el) => {
      if (el.classList.contains(val) && !el.classList.contains('empty')) {
        let cloneEl = el.cloneNode(true);
        cloneEl.removeAttribute('disabled');
        select_tmp_el.appendChild(cloneEl);
      }
    });
  }
  const select_three_els = document.getElementById('select_id_3').querySelectorAll('option');
  const select_tmp_three_el = document.getElementById('select_id_3_tmp');
  if (select_three_els.length > 0 && select_tmp_three_el) {
    Array.from(select_three_els).forEach((el) => {
      if (el.classList.contains(val) && el.value !== 'all') {
        let cloneEl = el.cloneNode(true);
        cloneEl.removeAttribute('disabled');
        select_tmp_three_el.appendChild(cloneEl);
      }
    });
  }
}

function hideAreaItems(area = false)
{
  if (area) {
    const el = document.getElementById('collapse-' + area);
    if (el) {
      const elements = el.querySelectorAll('div');
      if (elements) {
        elements.forEach((element) => {
          element.classList.replace('d-none', 'd-md-flex');
        })
      }
    }
  } else {
    const areas = document.querySelectorAll('.collapse-area');
    if (areas) {
      Array.from(areas).forEach((el) => {
        const elements = el.querySelectorAll('div');
        if (elements) {
          elements.forEach((element, i) => {
            if (i > 4) {
              element.classList.replace('d-md-flex', 'd-none');
            }
          })
        }
      })
    }
  }
}

export default {
  init() {

    if(window.location.hash) {
      const hash = window.location.hash
      const hashtarget = hash.split('?')[0]

      if(document.querySelector(hashtarget)) {
        document.querySelector(hashtarget).scrollIntoView({
          behavior: 'smooth',
        });
      }
    }
    if ($('.splide').length !== 0) {
      new Splide('.splide', {
        perPage: 3,
        gap: '1rem',
        pagination: false,
      }).mount();
    }
    //new Splide('.splide-videos').mount();

    if ($('.table-investors').length !== 0) {
      $('.table-investors').basictable();
    }

    if(localStorage.getItem('productview')) {
      const locals = localStorage.getItem('productview');
      const toggle = $('input[type=radio][name=productview]').val();

      if(toggle && locals !== toggle) {
        $('input[type=radio][name=productview][value=grid]').attr('checked', false)
        $('input[type=radio][name=productview][value=list]').attr('checked', true)
        $('.btn-group.btn-group-toggle').children('label').toggleClass('active')
        $('.display-container.products').toggle();
      }
    }

    const displayProductsEl = document.getElementById('display-products');
    let showAll = false;

    if(displayProductsEl){
      showAll = parseInt(displayProductsEl.dataset.showAll);
    }

    $('.products-block.products').each(function () {
      if($(this).children('div').children('div').children('div').children('a').length < 1) {
        if(!showAll){
          $(this).addClass('empty');
        }

        var emptyTag = $(this).attr('id');
        var emptyCat = $(this)[0].className.split(' ')[2];
        $('#select_id_2').find(`option.option-applications.${emptyCat}.${emptyTag}`).addClass('empty')
        $('#select_id_2').find(`option.option-applications.${emptyCat}.${emptyTag}`).siblings().addClass('hasValue')
        $('#select_id_2').children('.empty').attr('disabled', true)
      } else {
        $(this).addClass('hasValue');
      }
    })
  
    $('.products-block.grid-block').each(function () {
      if($(this).children('div').children().length < 1) {
        $(this).addClass('empty');
      } else {
        $(this).addClass('hasValue');
      }
    })

    $('.products-block.grid-block').each(function(){
      $(this).children('div').children().each(function() {
        const bla = this.className.replace(/ /g, '.');
        $(this).parent('div').children('div.' + bla).not(':last').hide();
      });
    });

    $('#select_id_2').find('option').attr('disabled', true)
    $('#select_id_3').find('option').attr('disabled', true)

    $('#select_id_2').find('option.all').removeAttr('disabled')
    $('#select_id_3').find('option.all').removeAttr('disabled')

    if($('#select_id').val() !== 'all') {
      const selected = $('#select_id').val();

      $('.display-container.products').children().addClass('hideThisCat')
      $('.display-container.products').children(`div.products-block.${selected}`).removeClass('hideThisCat')

      $('#select_id_2').find(`option.option-applications.${selected}`).addClass('showThis')
      $('#select_id_3').find(`option.option-materials.${selected}`).addClass('showThis')

      $('#select_id_2').find(`option.option-applications.${selected}.hasValue`).removeAttr('disabled')
      $('#select_id_3').find(`option.option-materials.${selected}`).removeAttr('disabled')
      $('#select_id_2').children('.empty').attr('disabled', true)

      if($('#select_id_2').val() !== 'all') {
        const selected_2 = $('#select_id_2').val();

        $('.display-container.products').children().addClass('hideThisTag')  
        $('.display-container.products').children(`div.products-block.products.${selected}.${selected_2}.hasValue.hideThisTag`).removeClass('hideThisTag')
        $('.display-container.products').children(`div.products-block.grid-block.${selected}.${selected_2}.hasValue.hideThisTag`).removeClass('hideThisTag')
      
        $('#select_id_3').val('all')
      }
    } else if(window.location.hash) {
      const hash = window.location.hash
      const hashtarget = hash.split('?')[0]
      const finalhash = hashtarget.split('#')[1]
      const cathash = finalhash.split('_')[0];
      const taghash = finalhash.split('_')[1];
      const thirdhash = finalhash.split('_')[2];

      const selecthash = $('#select_id').find(`option.${cathash}`).val();

      if(selecthash) {
        render_select(selecthash);
        $('#select_id').val(selecthash);

        $('.display-container.products').children().addClass('hideThisCat')
        $('.display-container.products').children(`div.products-block.${selecthash}`).removeClass('hideThisCat')

        $('#select_id_2').find(`option.option-applications.${selecthash}`).addClass('showThis')
        $('#select_id_3').find(`option.option-materials.${selecthash}`).addClass('showThis')

        $('#select_id_2').find(`option.option-applications.${selecthash}.hasValue`).removeAttr('disabled')
        $('#select_id_3').find(`option.option-materials.${selecthash}`).removeAttr('disabled')

        $('#select_id_2').children('.empty').attr('disabled', true)
      }

      if(taghash) {
        const selecttaghash = $('#select_id_2').find(`option.${taghash}`).val();
        if(selecttaghash) {
          $('#select_id_2').val(selecttaghash);
          $('.display-container.products').children().addClass('hideThisTag')  
          $('.display-container.products').children(`div.products-block.${selecttaghash}.hasValue`).removeClass('hideThisTag')
        }
      }

      if(thirdhash) {
        const selectthirdhash = $('#select_id_3').find(`option.${thirdhash}`).val();
        if(selectthirdhash) {
          $('#select_id_3').val(selectthirdhash);

          $('.display-container.products').children().children('div').children('div.items').addClass('hideThisMat')
          $('.display-container.products').children('div.hideThisMat').removeClass('hideThisMat')
          $('.display-container.products').children().children('div').children(`div.items.${selectthirdhash}`).removeClass('hideThisMat')

          var that = selectthirdhash;

          $('.product-category').addClass('hideThisMat')
          $(`.product-category.${that}`).removeClass('hideThisMat')

          $('.products-block').each(function () {
            var childValue = $(this).children('div').children(`div.items.${that}`).length
            var child2 = $(this).children('div.posts.row').children(`div.${that}`).children('div.post').children('a').length
  
            if(childValue < 1) {
              $(this).addClass('hideThisMat')
            }
  
            if(child2 > 0) {
              $(this).removeClass('hideThisMat')
            }
          });
        }
      }
    }

    // JavaScript to be fired on all pages
    if (document.getElementById('mainShareholders') !== null) {
      $.ajax({
        type: 'GET',
        url: '/wp-json/api/fetch/shares',
        success: populateBars,
      });
    }

    function populateBars(items) {
      const shareholdersBody = document.getElementById('shareholdersBody');
      const total = items.pop();
      let i = 0;
      var totalPercent = 0;
      var totalShares = 0;

      items.forEach((item) => {
        let shares = item.values.TOP_POSITION_SHARES_;
        totalShares = totalShares + shares;
        var percentOfTotal = (shares / total.values.TOTAL_NUMBER_OF_SHARES) * 100;
        totalPercent = totalPercent + percentOfTotal;
        percentOfTotal = Math.round(percentOfTotal * 100) / 100;
        var width = Math.ceil(percentOfTotal);
        shares = shares.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        const evenOdd = i % 2 == 0 ? 'even' : 'odd';
        let tr = document.createElement('tr');
        tr.setAttribute('class', 'middle ' + evenOdd);

        let td = document.createElement('td');
        td.setAttribute('class', 'first odd');
        td.innerHTML = item.values.TOP_INVESTOR_;
        tr.appendChild(td);

        td = document.createElement('td');
        if (i === 0) {
          td.innerHTML = '<div id="shareholderBars"><div id="div" style="width: 100%;"></div></div>';
        } else {
          $('#shareholderBars').append('<div id="div" style="width: ' + width * 3 + '%;"></div>');
        }
        tr.appendChild(td);

        td = document.createElement('td');
        td.setAttribute('class', 'middle even pos');
        td.innerHTML = shares;
        tr.appendChild(td);

        td = document.createElement('td');
        td.setAttribute('class', 'middle even pos');
        td.innerHTML = percentOfTotal + '%';
        tr.appendChild(td);

        td = document.createElement('td');
        td.setAttribute('class', 'middle odd');
        td.innerHTML = item.values.TOP_INVESTOR_ACCOUNT_TYPE_;
        tr.appendChild(td);

        td = document.createElement('td');
        td.setAttribute('class', 'last even');
        td.innerHTML = item.values.TOP_INVESTOR_COUNTRY_;
        tr.appendChild(td);

        shareholdersBody.appendChild(tr);
        i = i + 1;
      });

      const shareholdersBodyTotal = document.getElementById('shareholdersBodyTotal');

      totalPercent = totalPercent.toFixed(2);
      totalShares = totalShares.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      let tr = document.createElement('tr');
      tr.setAttribute('class', 'middle ');

      let td = document.createElement('td');
      td.setAttribute('class', 'first odd');
      td.innerHTML = '<strong>Total number owned by top 20</strong>';
      tr.appendChild(td);

      td = document.createElement('td');
      tr.appendChild(td);

      td = document.createElement('td');
      td.setAttribute('class', 'middle even pos');
      td.innerHTML = '<strong>' + totalShares + '</strong>';
      tr.appendChild(td);

      td = document.createElement('td');
      td.setAttribute('class', 'last even');
      td.innerHTML = '<strong>' + totalPercent + '%</strong>';
      tr.appendChild(td);

      td = document.createElement('td');
      tr.appendChild(td);

      td = document.createElement('td');
      tr.appendChild(td);

      shareholdersBodyTotal.appendChild(tr);
      i = i + 1;
    }

    var scroll = $(window).scrollTop();    
    if (scroll <= 100) {
      $('#nav-bar').removeClass('sticky');
      $('.sticky-logo').css({'display': 'none'})
      $('.init-logo').css({'display': 'block'})
    } else {
      $('#nav-bar').addClass('sticky');
      $('.sticky-logo').css({'display': 'block'})
      $('.init-logo').css({'display': 'none'})
    }
  
    if($('body').hasClass('product-items-template-default')) {
      $('#nav-bar').addClass('sticky');
    }

    if ($('body').hasClass('page-template-template-products')) {
      $('#nav-bar').addClass('sticky');

      $('.products-block .posts .post').each(function() {
        if ($(this).children('a').length < 4) {
          $(this).children('.button-spacer').hide();
        }
        if ($(this).children('a').length < 1) {
          $(this).parent().hide();
        }
      });
    }

    if ($('body').hasClass('search')) {
      $('#nav-bar').addClass('sticky');
    }

    if ($('body').hasClass('single-policies')) {
      $('#nav-bar').addClass('sticky');
    }

    if ($('body').hasClass('error404')) {
      $('#nav-bar').addClass('sticky');
    }

    if ($('body').hasClass('template-archive-reports')) {
      $('#nav-bar').addClass('sticky');
    }

    if ($('body').hasClass('template-archive-meetings')) {
      $('#nav-bar').addClass('sticky');
    }

    if ($('body').hasClass('template-archive-press-releases')) {
      $('#nav-bar').addClass('sticky');
    }

    if ($('body').hasClass('template-archive-stories-cases')) {
      $('#nav-bar').addClass('sticky');
    }

    if ($('body').hasClass('career-template-default')) {
      $('#nav-bar').addClass('sticky');
    }

    if ($('body').hasClass('press-releases-template-default')) {
      $('#nav-bar').addClass('sticky');
    }

    if ($('body').hasClass('template-contact')) {
      $('#nav-bar').addClass('sticky');
    }

    if ($('body').hasClass('template-archive-documents')) {
      $('#nav-bar').addClass('sticky');
    }

    // ScrollMagic
    let controller = new ScrollMagic.Controller();

    $('.fade-in').each(function (index, elem) {
      new ScrollMagic.Scene({
        triggerElement: elem,
        triggerHook: 0.8,
        offset: 50,
      })
      .setClassToggle(elem, 'faded')
      .reverse(false)
      .addTo(controller)
    });

    $('.timeline-fade-in').each(function (index, elem) {
      new ScrollMagic.Scene({
        triggerElement: elem,
        triggerHook: 0.8,
        offset: 50,
      })
      .setClassToggle(elem, 'timeline-faded')
      .reverse(false)
      .addTo(controller)
    });

    $('.hero-fade-in').each(function (index, elem) {
      new ScrollMagic.Scene({
        triggerElement: '.hero',
        triggerHook: 0.8,
        offset: 50,
      })
      .setClassToggle(elem, 'faded')
      .reverse(false)
      .addTo(controller)
    });

    if(document.cookie.indexOf('hasAccepted=true') !== -1) {
      //
    } else {
      setTimeout(() => {
        $('#cookiePopup').css('display', 'block');
      }, 4000);
    }

    $('.sticky-logo').css({'display': 'none'});

    $('#toggleMenu').click(function() {
      $('.expand-menu').toggleClass('open');
      $('.bannerNew').toggleClass('open');
      $('.menu-top').toggleClass('open');
      $('.menu-text').toggleClass('open');
      $('#overlay').fadeToggle();
      $('body').toggleClass('modal-open');
      $('#nav-icon3').toggleClass('open');
      $('.current-market').toggleClass('open');
    });

    $('#overlay').click(function() {
      $('.expand-menu').toggleClass('open');
      $('.bannerNew').toggleClass('open');
      $('.menu-top').toggleClass('open');
      $('.menu-text').toggleClass('open');
      $('#overlay').fadeToggle();
      $('body').toggleClass('modal-open');
      $('#nav-icon3').toggleClass('open');
      $('.current-market').toggleClass('open');
    });

    $('.current-market').click(function() {
      $('.expand-menu').removeClass('open');
      $('.bannerNew').removeClass('open');
      $('.menu-top').removeClass('open');
      $('.menu-text').removeClass('open');
      $('#nav-icon3').removeClass('open');
      $('#overlay').fadeOut();
      $('.current-market').removeClass('open');
    });

    $('<div class="toggleSubmenu"><span class="material-icons">close</span></div>').appendTo('.menu-item-has-children').on('click', function() {
      $(this).parent().children('ul').slideToggle('fast');
      $(this).toggleClass('open');
    });

    $('<span class="material-icons-outlined icon">arrow_forward</span>').insertAfter('.btn-readmore span');

    $('<span class="material-icons-outlined icon">arrow_forward</span>').insertAfter('.market .text');
    $('<span class="material-icons-outlined icon">arrow_forward</span>').insertAfter('.market-menu-class ul li a');

    const menuDropdowns = document.querySelectorAll('.solutions-nav-dropdown');
    if ( menuDropdowns ) {
      Array.from(menuDropdowns).forEach((el) => {
        const el_ID = el.getAttribute('id');
        const el_icon = document.querySelector(`.${el_ID} > svg`);
        $(`#${el_ID}`).on('show.bs.collapse', function () {
          el_icon.classList.add('open');
          Array.from(menuDropdowns).forEach((tmpEl) => {
            const el_tmp_ID = tmpEl.getAttribute('id');
            if (el_ID != el_tmp_ID) {
              $(`#${el_tmp_ID}`).collapse('hide');
              document.querySelector(`.${el_tmp_ID} > svg`).classList.remove('open');
            }
          });
        });
        $(`#${el_ID}`).on('hide.bs.collapse', function () {
          el_icon.classList.remove('open');
        });
      });
    }

    $('#carousel-block').carousel({interval: 5000});

    
    const vimeo = document.getElementById('vimeo');
    let vimeoPlayer;
    if (vimeo) {
      const vimeo_id = vimeo.dataset.vimeo;
      const options = {
          id: vimeo_id,
          width: 640,
          loop: true,
          autoplay: true,
          background: true,
      };
      vimeoPlayer = new Player('vimeo-player', options);

      const volume = document.getElementById('volume');

      volume.addEventListener('click', toggleVolume, false);
    }

    function toggleVolume() {
      vimeoPlayer.getMuted().then(function(muted) {
        console.log(document.querySelector('.muted'));
          if(muted) {
            vimeoPlayer.setMuted(false);
            document.querySelector('.muted').classList.toggle('hide');
            document.querySelector('.unmuted').classList.toggle('hide');
          } else {
            vimeoPlayer.setMuted(true);
            document.querySelector('.muted').classList.toggle('hide');
            document.querySelector('.unmuted').classList.toggle('hide');
          }
      }).catch(function() {
          // an error occurred
      });
    }

    hideAreaItems();
    const areaBtn = document.querySelectorAll('.area-collapse');
    if (areaBtn) {
      Array.from(areaBtn).forEach((el) => {
        el.addEventListener('click', (e) => {
          e.preventDefault();
          hideAreaItems(e.target.dataset.index);
          el.remove();
        });
      });
    }

    const instagraContainer = document.getElementById('instagram-list');

    if (instagraContainer) {
      var i;
      let html = '';
      let imgUrl = '';
      const endpoint = '/wp-json/v1/instagramfeed/1';
      fetch(endpoint)
        .then((response) => response.json())
        .then((response) => {
          for (i = 0; i < 6; i++) {
            if (response.data[i].thumbnail_url) {
              imgUrl = response.data[i].thumbnail_url;
            } else {
              imgUrl = response.data[i].media_url;
            }
            html += `<div class=""><a href="${response.data[i].permalink}" target="_blank"><div class="instagram-image-wrapper"><div class="instagram-image-wrapper-inner"><img src="${imgUrl}" class="img-fluid" alt=""/>
              </div></div></a></div>`;
          }
          instagraContainer.innerHTML = html;
        })
        .catch((error) => {
          console.log(error);
        });
    }
    
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    const formFilterEl = document.getElementById('table-filter-products');
    if (formFilterEl) {
      formFilter(formFilterEl);
    }
    const filterCol = document.querySelectorAll('.toggle-filter-item');
    if (filterCol) {
      Array.from(filterCol).forEach((el) => {
        el.addEventListener('click', (e) => {
          const element = e.currentTarget;
          const target = element.dataset.target;
          element.classList.toggle('active');
          document.getElementById(target).classList.toggle('d-none');
        });
      });
    }

    const map = document.querySelector('.acf-map');
    const sentinel = document.getElementById('bewiLocations');
    if (sentinel) {
      const intersectionObserver = new IntersectionObserver((entries) => {
        if (entries[0].intersectionRatio <= 0) {
          return;
        }
        bewiMap(map);
        intersectionObserver.unobserve(entries[0].target);
      });
      intersectionObserver.observe(sentinel);
    }

    $('#pm-year-archive').on('change', function () {
      if(this.value == 'all') {
        $('#pressReleasesList').children().removeClass('hideThisYear');
      } else {
        $('#pressReleasesList').children().addClass('hideThisYear');
        $(`.y-${this.value}`).removeClass('hideThisYear');
      }
    });

    $('#category-archive').on('change', function () {
      if(this.value == 'regulatory') {
        $('#pressReleasesList').children('.not-regular').addClass('hideThis');
      } else {
        $('#pressReleasesList').children('.not-regular').removeClass('hideThis');
      }
    });

    $('input[type=radio][name=showPressReleasesArchive]').on('change', function() {
      if(this.value == 'regulatory') {
        $('#pressReleasesList').children('.not-regular').addClass('hideThis');
      } else {
        $('#pressReleasesList').children('.not-regular').removeClass('hideThis');
      }
    });

    $('input[type=radio][name=productview]').on('change', function() {
      $('.display-container.products').toggle();
      localStorage.setItem('productview', this.value)
    });
    
    if($('body').hasClass('template-newsroom')) {
      var ppp = 6;
      var pageNumber = 0;
      var year = '';
      var cat = 210;

      load_posts();

      $('#pm-year').change(function () {
        $('.pm-container').remove();
        year = this.value;
        pageNumber = 0;
        load_posts();
      });

      $('input[type=radio][name=showPressReleases]').change(function() {
        $('.pm-container').remove();
        if (this.value == 'all') {
          cat = 210;
        }
        else if (this.value == 'regulatory') {
          cat = 180;
        }
        pageNumber = 0;
        load_posts();
      });

      $('#category').change(function() {
        $('.pm-container').remove();
        if (this.value == 'all') {
          cat = 210;
        }
        else if (this.value == 'regulatory') {
          cat = 180;
        }
        pageNumber = 0;
        load_posts();
      });
    }

    function load_posts(){
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const currentLang = urlParams.get('lang')
      pageNumber++;
      var str = '&pageNumber=' + pageNumber + '&ppp=' + ppp + '&year=' + year + '&cat=' + cat + '&action=more_post_ajax&lang=' + currentLang;
      //console.log(ajax_posts.ajaxurl);
      console.log(str);
      $.ajax({
        type: 'POST',
        dataType: 'html',
        // eslint-disable-next-line no-undef
        url: ajax_posts.ajaxurl,
        data: str,
        success: function(data){
          var $data = $(data);
          if($data.length){
              $('#pressReleasesList').append($data);
              $('#more_posts').attr('disabled',false);
          } else {
              $('#more_posts').attr('disabled',true);
          }
        },
        error : function(jqXHR, textStatus, errorThrown) {
          // eslint-disable-next-line no-undef
          $loader.html(jqXHR + ' :: ' + textStatus + ' :: ' + errorThrown);
        },

      });
      return false;
    }

    $('#more_posts').on('click',function(){ // When btn is pressed.
        $('#more_posts').attr('disabled',true); // Disable the button, temp.
        load_posts();
    });

    $('.overlay-link').hover(function() {
      $(this).parent().children('img').toggleClass('hovered');
    });

    $('#manageCookie').on('click', function() {
      $('#cookiePopup').hide();
      $('#cookiePopupManage').show();
    });

    $('#manageCookies').on('click', function() {
      $('#cookiePopupManage').show();
    });

    $('.acceptCookie').on('click', function() {
      setCookie();
    });

    $('.cookiePreference').on('click', function() {
      if(document.getElementById('cookieType1').checked == true) {
        const date = new Date();
        // Cookie is valid 1 year: now + (days x hours x minutes x seconds x milliseconds)
        date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
        // Set cookie
        document.cookie = `cookieType=necessary;expires=${date.toUTCString()};path=/`;
        document.cookie = `hasAccepted=true;expires=${date.toUTCString()};path=/`;
        $('#cookiePopup').hide();
        $('#cookiePopupManage').hide();
      } else {
        setCookie();
      }
    });

    function setCookie() {
      const date = new Date();
      // Cookie is valid 1 year: now + (days x hours x minutes x seconds x milliseconds)
      date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
      // Set cookie
      document.cookie = `cookieType=all;expires=${date.toUTCString()};path=/`;
      document.cookie = `hasAccepted=true;expires=${date.toUTCString()};path=/`;
      $('#cookiePopup').hide();
      $('#cookiePopupManage').hide();
    }

    /*$('.news-block').on('click', function() {
      const link = $(this).children().children('div').children('a').attr('href');
      window.location = link;
    });*/

    if (
      !$('body').hasClass('product-items-template-default') &&
      !$('body').hasClass('page-template-template-products') &&
      !$('body').hasClass('search') &&
      !$('body').hasClass('error404') &&
      !$('body').hasClass('template-archive-reports') &&
      !$('body').hasClass('template-archive-meetings') &&
      !$('body').hasClass('template-archive-stories-cases') &&
      !$('body').hasClass('career-template-default') &&
      !$('body').hasClass('press-releases-template-default') &&
      !$('body').hasClass('single-policies') &&
      !$('body').hasClass('template-contact') &&
      !$('body').hasClass('template-archive-press-releases') &&
      !$('body').hasClass('template-archive-documents')
    ) {
      $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        if (scroll <= 100) {
          $('#nav-bar').removeClass('sticky');
          $('.sticky-logo').css({'display': 'none'})
          $('.init-logo').css({'display': 'block'})
        } else {
          $('#nav-bar').addClass('sticky');
          $('.sticky-logo').css({'display': 'block'})
          $('.init-logo').css({'display': 'none'})
        }
      });
    }

    if(!$('body').hasClass('product-items-template-default')) {
      document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
    
            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth',
            });
        });
      });
    }

    $('#select_id').on('change', function () {
      clear_select('select_id_2_tmp');
      clear_select('select_id_3_tmp');
      if(this.value == 'all') {
        $('.display-container.products').children().removeClass(['hideThisCat', 'hideThisTag', 'hideThisMat']);
        $('.display-container.products').children().children('div').children('div.items').removeClass('hideThisMat');
        $('.product-category').removeClass('hideThisMat')
      } else {
        $('.display-container.products').children().addClass('hideThisCat')
        $('.display-container.products').children(`div.products-block.${this.value}.hasValue`).removeClass('hideThisCat')
        render_select(this.value);
      }
    });

    $('#select_id_2_tmp').on('change', function () {
      if(this.value == 'all') {
        $('.display-container.products').children().removeClass('hideThisTag')
      } else {
        $('.display-container.products').children().addClass('hideThisTag')  
        $('.display-container.products').children(`div.products-block.${this.value}.hasValue`).removeClass('hideThisTag')
      }
    });

    $('#select_id_3_tmp').on('change', function () {
      if(this.value == 'all') {
        $('.display-container.products').children().children('div').children('div.items').removeClass('hideThisMat')
        $('.display-container.products').children('div.hideThisMat').removeClass('hideThisMat')
        $('.product-category').removeClass('hideThisMat')
      } else {
        let val = this.value.replace(/\s/g, '');
        $('.display-container.products').children().children('div').children('div.items').addClass('hideThisMat')
        $('.display-container.products').children('div.hideThisMat').removeClass('hideThisMat')
        $('.display-container.products').children().children('div').children(`div.items.${val}`).removeClass('hideThisMat')

        var that = val;

        $('.product-category').addClass('hideThisMat')
        $(`.product-category.${that}`).removeClass('hideThisMat')

        $('.products-block').each(function () {
          var childValue = $(this).children('div').children(`div.items.${that}`).length
          var child2 = $(this).children('div.posts.row').children(`div.${that}`).children('div.post').children('a').length

          if(childValue < 1) {
            $(this).addClass('hideThisMat')
          }

          if(child2 > 0) {
            $(this).removeClass('hideThisMat')
          }
        });
      }
    });
    // const selectElement = document.querySelector('.select-country');

    // selectElement.addEventListener('change', (event) => {
    //   const country = event.target.value;

    // });
    $('.select-contact-posts').change(function() {
      const country = $('#select_contact_post').val() !== 'all' ? $('#select_contact_post').val() : '';
      const area = $('#select_contact_post_2').val() !== 'all' ? $('#select_contact_post_2').val() : '';

      const endpoint = `/wp-json/api/fetch/contacts/?country=${country}&area=${area}`;
      //const endpoint = '/wp-json/api/fetch/contacts';
      const container = document.getElementById('list-contacts');
      fetch(endpoint)
      .then((response) => response.json())
      .then((result) => {
        container.innerHTML = result;
      });
      
    })

    $('#select_contact_manual').on('change', function() {
      const area = this.value !== 'all' ? this.value : null;
      if (area) {
        $('#container-contacts').children().hide();
        $(`#jump-block-${area}`).show();
        document.getElementById(`jump-block-${area}`).scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start'});
      } else {
        $('#container-contacts').children().show();
      }
    });

    $('.select-contact').change(function() {
      const country = $('#select_contact').val() !== 'all' ? $('#select_contact').val() : null;
      const area = $('#select_contact_2').val() !== 'all' ? $('#select_contact_2').val() : null;

      if(country && area) {
        const toshow = $('.contacts').children(`div.contact-block.${country}.${area}`);
        $('.contacts').children().css({'display' : 'none'});
        toshow.css({'display' : 'block'});
        return;
      } else if(country) {
        const toshow = $('.contacts').children(`div.contact-block.${country}`);
        $('.contacts').children().css({'display' : 'none'});
        toshow.css({'display' : 'block'});
        return;
      } else if (area) {
        const toshow = $('.contacts').children(`div.contact-block.${area}`);
        $('.contacts').children().css({'display' : 'none'});
        toshow.css({'display' : 'block'});
        return;
      } else {
        $('.contacts').children().css({'display' : 'flex'});
      }
    })
    
    $('.select-contact').change(function() {
      const country = $('#select_contact').val() !== 'all' ? $('#select_contact').val() : null;
      const area = $('#select_contact_2').val() !== 'all' ? $('#select_contact_2').val() : null;

      if(country && area) {
        const toshow = $('.display-container.office').children(`div.office-block.${country}.${area}`);
        $('.display-container.office').children().css({'display' : 'none'});
        toshow.css({'display' : 'block'});
        return;
      } else if(country) {
        const toshow = $('.display-container.office').children(`div.office-block.${country}`);
        $('.display-container.office').children().css({'display' : 'none'});
        toshow.css({'display' : 'block'});
        return;
      } else if (area) {
        const toshow = $('.display-container.office').children(`div.office-block.${area}`);
        $('.display-container.office').children().css({'display' : 'none'});
        toshow.css({'display' : 'block'});
        return;
      } else {
        $('.display-container.office').children().css({'display' : 'block'});
      }
    })

    $('.expand-this').click(function() {
      $(this).parent().parent().children('a').toggleClass('toggle');
      $(this).toggleClass('toggleIcon');
    });

    $('.products-block .posts .post a').hover(function() {
      $(this).parent().toggleClass('hovered');
    })

    $('.products-block .posts .post button').hover(function() {
      $(this).parent().toggleClass('hovered');
    })

    $('#expandText').click(function() {
      $('.expandTextOpen').toggleClass('open');
      $(this).toggleClass('toggleIcon');
      $(this).children().toggleClass('active');
    });

    $('#showAnalysts').click(function() {
      $('.expanded').toggleClass('open');
      $(this).toggleClass('toggleIcon');
      $(this).children().toggleClass('active');
    });

    $('.showAnalystName').click(function() {
      $(this).parent().next().toggleClass('active');
      $(this).children().toggleClass('toggleIcon');
    });

    $('#show-policy').click(function() {
      $(this).toggleClass('toggleIcon');
      $(this).parent().parent().next().toggleClass('open');
      $(this).children().toggleClass('active');
    });

    $('#ir-articles-button').click(function() {
      $(this).toggleClass('toggleIcon');
      $(this).parent().parent().next().toggleClass('open');
      $(this).children().toggleClass('active');
    });

    $('#financingShowMore').click(function() {
      $(this).toggleClass('toggleIcon');
      $('.group-collapsed').toggleClass('collapsed');
      $(this).children().toggleClass('active');
    })

    var showPopupBtn = document.querySelectorAll('.showPopup');
    var backdropID = document.querySelectorAll('.backdrop');
    var hidePopupBtn = document.querySelectorAll('.hidePopup');
    
    for (var i = 0; i < backdropID.length; i++) {
      backdropID[i].id = 'popup-' + i;
    }
    for (var dataOpen = 0; dataOpen < showPopupBtn.length; dataOpen++) {
      showPopupBtn[dataOpen].setAttribute('data-popup', 'popup-' + dataOpen);
    }

    showPopupBtn.forEach(function(btn) {
      btn.onclick = function() {
        var popup = btn.getAttribute('data-popup');
        document.getElementById(popup).style.display = 'flex';
      }
    });

    for (var dataClose = 0; dataClose < hidePopupBtn.length; dataClose++) {
      hidePopupBtn[dataClose].setAttribute('data-popup', 'popup-' + dataClose);
    }
  
    hidePopupBtn.forEach(function(btn) {
      btn.onclick = function() {
        var popup = btn.getAttribute('data-popup');
        document.getElementById(popup).style.display = 'none';
      };
    });  

    window.onclick = function (e) {
      if (e.target.className === 'backdrop') {
        e.target.style.display = 'none';
      }
    }

    lightbox.option({
      'disableScrolling': true,
      'showImageNumberLabel': false,
    })
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js